import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginRedirectGuardService implements CanActivate {
  public constructor(private readonly authService: AuthService, private readonly router: Router) {
  }

  public async canActivate(): Promise<boolean | UrlTree> {
    const authorized: boolean = await firstValueFrom(this.authService.isUserAuthorized$());

    if (!authorized) {
      return true;
    }

    return this.router.createUrlTree(['']);
  }
}
